<template>
  <div class="menu">
    <div class="menu-item" @click="routerClick('/')" :class="{active: $route.path==='/'}">
      <i class="icon menu-icon icon-fuwu"></i>
      <span>首页</span>
    </div>
    <div
      class="menu-item"
      @click="routerClick('/chat_list')"
      :class="{active: $route.path==='/chat_list'}"
    >
      <i class="icon menu-icon icon-msg"></i>
      <span class="num-icon" v-if="message_num>0">{{message_num>99?message_num+'+':message_num}}</span>
      <span>咨询</span>
    </div>
    <div class="menu-item" @click="routerClick('/my')" :class="{active: $route.path==='/my'}">
      <i class="icon menu-icon icon-my"></i>
      <span>我的</span>
    </div>
  </div>
</template>

<script>
export default {
  name: "tabbar",
  data() {
    return {
      message_num:0
    };
  },
  created() {},
  mounted() {
    this.chats.forEach(v => {
      console.log(v)
       this.message_num +=v.message_num?(+v.message_num):0;
    })
  },
  computed:{
    chats(){
      return this.$store.state.chat_list;
    },
    isIphoneX(){
      return this.$store.state.isIphoneX;
    }
  },
  watch:{
    'chats':{
      handler(val){
        console.log(val,'val')
        this.message_num = 0;
        val.forEach(v => {
          this.message_num +=v.message_num?(+v.message_num):0;
        })
      },
      deep:true
    },
  },
  methods: {
    routerClick(path) {
      this.$router.push(path);
    },
  },
};
</script>
<style scoped>
.menu {
  width: 100%;
  background: #fff;
  height: 3rem;
  position: fixed;
  bottom: 0;
  left: 0;
  display: flex;
  align-items: flex-start;
  padding-top: 0.2rem;
  justify-content: space-around;
  border-top: #e2e2e2 0.05rem solid;
}
.menu-x{
  height: 4.1rem;
  padding-bottom: 1.7rem;
}
.menu-item {
  width: auto;
  text-align: center;
  font-size: 0.5rem;
  color: rgba(0, 0, 0, 0.45);
  position: relative;
}
.menu-item span{
  font-size: 0.5rem;
  line-height: 1;
}
.icon {
  display: inline-block;
  content: url("./../../../static/icons/news_no@2x.png");
}
.menu-icon {
  width: 1.097rem;
  height: 1.097rem;
  display: block;
  margin: 0 auto;
  margin-bottom: 0.2rem;

}
.icon-fuwu {
  content: url("./../../../static/icons/serbeno@2x.png");
}
.icon-msg {
  content: url("./../../../static/icons/newsno@2x.png");
}
.icon-my {
  content: url("./../../../static/icons/mineno@2x.png");
}
.menu-item.active {
  color: #1890FF;
}
.menu-item.active .icon-fuwu {
  content: url("./../../../static/icons/serbeyes@2x.png");
}
.menu-item.active .icon-msg {
  content: url("./../../../static/icons/newsyes@2x.png");
}
.menu-item.active .icon-my {
  content: url("./../../../static/icons/mineyes@2x.png");
}
.num-icon {
  height: 0.6rem;
  font-size: 0.5rem;
  color: #fff;
  background: #fa541c;
  padding: 0 0.25rem;
  border-radius: 0.3rem;
  position: absolute;
  right: -0.4rem;
  top: -0.05rem;
  display: flex;
  justify-content: center;
  align-items: center;
}
</style>



// WEBPACK FOOTER //
// src/components/tabbar/tabbar.vue